import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useDossierCustomHeader } from '@europrocurement/l2d-modules';

const DossierDetailCustomHeader: React.FunctionComponent = function () {
    const { palette } = useTheme();
    const { headerTitle, actionsBloc } = useDossierCustomHeader();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
            }}
        >
            <Typography
                variant="l2dh7"
                sx={{ color: palette.secondary.main }}
            >
                {headerTitle || 'Vérifier les informations du dossier'}
            </Typography>

            <Box sx={{ display: 'flex' }}>{actionsBloc}</Box>
        </Box>
    );
};

export default DossierDetailCustomHeader;
